function updateDaySelected(emit, day) {
    emit("changeDay", day);
}

export default updateDaySelected;
